module.exports = __webpack_public_path__ + "img/宁波弘启金属.13020035.jpg";